import React from 'react';

import useStyles from './styles';
import ListItemLink from './listItemLink';

import { Typography, Box, List, Divider } from '@material-ui/core';
import Settings from '@material-ui/icons/Settings';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ContactMail from '@material-ui/icons/ContactMail';
import Person from '@material-ui/icons/Person';

import currentUserSelector from '../../../../../selectors/currentUserSelector';
import { useSelector } from 'react-redux';

function UserProfile({ user, handleClose, onClickSetting, onClickLogout }) {
  const classes = useStyles();
  console.log("User Profile", user);
  const { firstName, lastName = '', email } = user;
  const currentUser = useSelector(currentUserSelector);
  console.log("User Profile currentUser", currentUser);

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography>My Profile</Typography>
      </Box>
      <Box className={classes.content}>
        <Box padding="4px 24px 8px 16px">
          <Typography className={classes.title}>{`${firstName} ${lastName}`} </Typography>
          <Typography className={classes.subtitle}>{email} </Typography>
        </Box>
        <Box className={classes.listItem}>
          <List>
            <Divider light />
            <ListItemLink to='/brands' primary='Add a social profile' icon={Person} onClickHandleClose={handleClose} />
            <ListItemLink
              disabled={currentUser?.userRole.toString() === "2"}
              to='/team' primary='Invite a team member'
              icon={ContactMail}
              onClickHandleClose={handleClose} />
            <ListItemLink primary={'Settings'} icon={Settings} onClickHandleClose={handleClose} onClickHandleAction={onClickSetting} />
            <Divider light />
            <ListItemLink primary={'Logout'} icon={ExitToApp} onClickHandleClose={handleClose} onClickHandleAction={onClickLogout} />
          </List>
        </Box>
      </Box>
    </Box>
  )
}

export default UserProfile;
